import type { ChartDefinition } from '../catalog/types';
import type { UserInDto } from 'shared/domain/user/types/inDto';

export function resolveChartCanAccess(
  definition: ChartDefinition,
  user: UserInDto
): boolean {
  if (definition.accessMode === 'role') {
    return definition.canAccess?.(user) ?? false;
  }

  if (definition.accessMode === 'hook') {
    return definition.canAccess?.(user) ?? true;
  }

  return true;
}
